// Application constants
export const TokenKey = 'ACCESS_TOKEN';
export const TokenPre = 'Bearer ';

export const LockedKey = 'LockedKey';
export const salt = 'EIpWsyfiy@R@X#qn17!StJNdZK1fFF8iV6ffN!goZkqt#JxO';

// Layout constants
export const SideNavWidth = 208;
export const CollapsedNavWidth = 48;

// Theme mode constants
export type ThemeMode = 'light' | 'dark' | 'auto';

// Navigation constants
export const IsFirstLogin = 'IS_FIRST_LOGIN';

// Layout mode
export type LayoutMode = 'side' | 'top' | 'mixin';

// Additional constants for theme settings
export const StyleThemeModelKey = 'STYLE_THEME_MODEL';
export const ThemeOptionsKey = 'THEME_OPTIONS';

export const SideCollapsedMaxWidth = 700;
export const TopCollapsedMaxWidth = 1247;

export const UserInfoKey = 'USER_INFO';
export const MenuInfoKey = 'MENUS_INFO';
export const FunctionInfoKey = 'FUNCTIONS_INFO';
export const TokenInfoKey = 'auth_token';
export const AccessTokenExpirationKey = 'access_token_expiration';
export const RefreshTokenExpirationKey = 'refresh_token_expiration';